import React from 'react';
import { withFormik } from 'formik';
import validationSchema from './validationSchema';
import mapPropsToValues from './mapPropsToValues';

const formikEnhancer = withFormik({
  validationSchema,
  mapPropsToValues,
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
  displayName: 'EnhancedForm',
});

export default WrappedForm => {
  const withValidation = ({ ...props }) => {
    const EnhancedForm = formikEnhancer(WrappedForm);
    return <EnhancedForm {...props} />;
  };

  return withValidation;
};



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/Form/withValidation.js